import { Icon } from "#shared/icons/Icon";
import { Anchor } from "#shared/view/components/Anchor";
import { Menu } from "#shared/view/components/Menu";
import { File } from "shared";

type Props = {
  files: File[] | null | undefined;
  children: React.ReactNode;
};

export const DocumentsContainer = ({ files, children }: Props) => {
  return (
    <Menu shadow="md" width={"max-content"}>
      <Menu.Target>{children}</Menu.Target>

      <Menu.Dropdown>
        {files?.map((file) => (
          <Menu.Item
            leftSection={<Icon name="download" size={14} />}
            disabled={!file.url}
            w="100%"
            key={file.id}
          >
            <Anchor
              href={file.url}
              style={{ textDecoration: "none" }}
              component="a"
              c="inherit"
              target="_blank"
              rel="noopener noreferrer"
              download
              size="xs"
            >
              {file.name}
            </Anchor>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
